import 'zone.js';
import '@angular/localize/init';
import 'core-js/es/reflect';